module.exports = __webpack_public_path__ + "static/img/3.3ae4ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/m/3.png
// module id = 2x3N
// module chunks = 1 2